import { Box } from '@chakra-ui/react';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { MouseEvent } from 'react';

type Props = {
  isVisible: boolean;
  onToggle: () => void;
  ariaLabel: string;
};

const PasswordVisibilityToggle = ({
  isVisible,
  onToggle,
  ariaLabel
}: Props) => {
  return (
    <Box
      as="button"
      type="button"
      onClick={onToggle}
      onMouseDown={(event: MouseEvent<HTMLButtonElement>) =>
        event.preventDefault()
      }
      aria-label={ariaLabel}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      h="100%"
      px={2}
      color="actionPrimaryContentInverse"
      cursor="pointer"
    >
      <FontAwesomeIcon icon={isVisible ? faEyeSlash : faEye} />
    </Box>
  );
};

export default PasswordVisibilityToggle;
